module.exports = __webpack_public_path__ + "public/img/chanliang_3.21114003.png";